module.exports = __webpack_public_path__ + "img/20.02613dc8.png";